import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { SearchType } from '@search-bar/entities/search-type';
import { tap } from 'rxjs';

import {
  TypographyColor,
  TypographyFontFamily,
  TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { AvoService } from '@avo/services/avo.service';
import { EVENT_SOURCE } from '@app/modules/core/constants/amplitude.constants';
import { SearchBy } from '@shared/base-search-bar/entities/search.entities';
import { AvoDispatchOrchestrator } from '@avo/orchestrator/avo.dispatch';

@Component({
  selector: 'app-no-module-available',
  templateUrl: './no-module-available.component.html',
  styleUrls: ['./no-module-available.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NoModuleAvailableComponent implements OnChanges {

  private source = EVENT_SOURCE.TRAVEL_HOME;
  protected AvoDispatch = new AvoDispatchOrchestrator();

  @Input() searchType: SearchType;

  constructor(
    protected avoService: AvoService
  ) {}

  ngOnChanges(): void {
    this.viewTravelSearchScreenEvent();
  }

  get fontSize(): typeof TypographyFontSize {
    return TypographyFontSize;
  }

  get fontFamily(): typeof TypographyFontFamily {
    return TypographyFontFamily;
  }

  get fontColor(): typeof TypographyColor {
    return TypographyColor;
  }

  get image(): string {
    return 'download-app-qr-code.svg';
  }

  get textByProduct(): string {
    const translatationBase = 'NO_MODULE_AVAILABLE.BULLET_BY_PRODUCT.';
    switch(this.searchType) {
      case SearchType.HOME_AUTOS:
        return `${translatationBase}AUTOS`;
      case SearchType.HOME_BYHOURS:
        return `${translatationBase}BY_HOURS`;
      default:
        return null;
    } 
  }

  get searchBy(): SearchBy {
    switch(this.searchType) {
      case SearchType.HOME_BYHOURS:
        return SearchBy.BYHOURS;
      case SearchType.HOME_AUTOS:
        return SearchBy.AUTOS;
      default:
        return null;
    }
  }

  private viewTravelSearchScreenEvent(): void {
    this.avoService.getEventTriggerProps$().pipe(
      tap(trigger =>
        this.AvoDispatch.viewTravelSearchScreen({
          ...this.avoService.avoBaseProperties(trigger),
          source: this.avoService.getAvoSourceValueType(this.source),
          travelProductType: this.searchBy
        })
      )
    ).subscribe().unsubscribe();
  }

}
